import template from "./export-actions.html";
import "./export-actions.less";
import { FORM_EXPORT_ENQUEUE } from "../../routes";

export class Controller {
	constructor(appState, api, loadingService, toastr, $logger) {
		this.appState = appState;
		this.api = api;
		this.loadingService = loadingService;
		this.toastr = toastr;
		this.$logger = $logger;
	}

	async reQueue() {
		const formId = this.formId;
		const configCode = this.configExports[0].Log.Configuration.Code;
		const reportId = this.reportId;
		const queueRequest = { Reports: [{ Id: reportId }] };

		try {
			await this.loadingService.watch(this.api.post(FORM_EXPORT_ENQUEUE(formId, configCode), queueRequest));
			this.toastr.success("Report re-queued successfully");
		}catch(error) {
			this.toastr.error("Failed to re-queue report");
			this.$logger.error(error);
		}
	}
}

export default angular
	.module("vesl.components.export-actions", [])
	.component("exportActions", {
		template,
		controller: Controller,
		bindings: {
			configExports: "<",
			isSysAdmin: "<",
			reportId: "<",
			formId: "<"
		}
	}).name;